<template>
  <div v-if="npc" class="person" :class="`person--${name}`" :style="`--npcwidth: ${npc.Width}px; --npcbottom: ${npc.Bottom}px;`">
    <div v-if="hasSprites" class="person__container">
      <div class="person__inner">
        <!-- stand (right) -->
        <img
          v-for="count in 4"
          :key="`ls-${count - 1}`"
          :alt="name"
          :src="npc.RightStand[count - 1] ? npc.RightStand[count - 1] : npc.RightStand[0]"
        >
      </div>
    </div>
    <div v-if="speechbubble" class="speechbubble">
      {{ speechbubble }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'UndergroundNpc1',

  props: {
    speechbubble: {
      default: () => '',
      type: String
    },
    npcs: {
      default: () => {},
      type: [Array, Object]
    }
  },

  computed: {
    npc () {
      if (this.npcs) {
        return this.npcs
      }
      return null
    },
    hasSprites () {
      if (this.npc) {
        if (
          this.npc.RightStand.length > 2
        ) {
          return true
        }
      }
      return false
    }
  },

  data () {
    return {
      name: 'npc'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/landing/mixins.scss';

.speechbubble {
  z-index: 1;
  bottom: 80%;
  left: 40%;
  width: 150px;
}

$delay: 1.5s;
$duration: 1s;
.person--npc {
  left: 0;
  bottom: 55px;
  bottom: calc(66px - var(--npcbottom));
  width: 0;
  width: var(--npcwidth);
  overflow: visible;

  @include breakpoint(lg) {
    top: 523px;
    top: calc(512px + var(--npcbottom));
    bottom: auto;
    left: 40px;
    transform: translateY(-100%);
  }

  .person__inner {
    transform: translate3d(0, 0, 0);
    animation: npc-animate $duration steps(1) infinite $delay;

    img {
      width: var(--npcwidth);
      min-width: var(--npcwidth);
    }
  }
}
@keyframes npc-animate {
  0% {
    transform: translate3d(0, 0, 0);
  }
  33.333% {
    transform: translate3d(calc(var(--npcwidth) * -1), 0, 0);
  }
  66.666% {
    transform: translate3d(calc(var(--npcwidth) * -2), 0, 0);
  }
  100% {
    transform: translate3d(calc(var(--npcwidth) * -3), 0, 0);
  }
}
</style>
